import * as httpx from '../httpx.js';

// DOM ELEMENTS
const userDataForm = document.querySelector('.form-user-data');
const userInviteForm = document.querySelector('.form-user-invite');
const userPasswordForm = document.querySelector('.form-user-password');

// Helper function to convert file to base64
const convertToBase64 = file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
};

// Helper function to populate dropdown
function populateDropdown(elementId, list) {
  const element = document.getElementById(elementId);
  list.forEach(item => {
    const option = document.createElement('option');
    option.value = item.id;
    option.text = item.name;
    element.appendChild(option);
  });
}

// Setup user data form
function setupUserDataForm() {
  if (userDataForm)
    userDataForm.addEventListener('submit', async e => {
      e.preventDefault();
      const url = '/api/v1/users/updateMe';
      const method = 'PATCH';
      const data = {};
      data.userName = document.getElementById('name').value;
      data.email = document.getElementById('email').value;

      const photoFile = document.getElementById('photo').files[0];
      if (photoFile) {
        try {
          data.photo = await convertToBase64(photoFile);
        } catch (err) {
          showAlert('error', 'Error processing image');
          return;
        }
      }

      await httpx.updateOrCreateRecord(data, url, method, 'User');
    });
}

// Setup password change form
function setupPasswordForm() {
  if (userPasswordForm)
    userPasswordForm.addEventListener('submit', async e => {
      e.preventDefault();
      const url = '/api/v1/users/updatePwd';
      const method = 'PATCH';
      document.querySelector('.btn--save-password').textContent = 'Updating...';
      const passwordCurrent = document.getElementById('password-current').value;
      const password = document.getElementById('password').value;
      const passwordConfirm = document.getElementById('password-confirm').value;
      await httpx.updateOrCreateRecord(
        { passwordCurrent, password, passwordConfirm },
        url,
        method,
        'Password',
      );

      document.querySelector('.btn--save-password').textContent =
        'Save password';
      document.getElementById('password-current').value = '';
      document.getElementById('password').value = '';
      document.getElementById('password-confirm').value = '';
    });
}

// Setup user invite form
function setupUserInviteForm() {
  if (userInviteForm) {
    const companies = JSON.parse(userInviteForm.getAttribute('companies'));
    populateDropdown('company', companies);

    userInviteForm.addEventListener('submit', async e => {
      e.preventDefault();
      const url = '/api/v1/users/invite';
      const method = 'POST';
      const data = {};

      data.userName = document.getElementById('name').value;
      data.email = document.getElementById('email').value;
      data.role = document.getElementById('role').value;

      const selectedCompanyDropdown = document.getElementById('company');
      let selectedCompanyIds;
      if (selectedCompanyDropdown !== null) {
        selectedCompanyIds = Array.from(
          selectedCompanyDropdown.selectedOptions,
        ).map(option => option.value);
      } else {
        selectedCompanyIds = '';
      }

      data.company = selectedCompanyIds;

      const success = await httpx.updateOrCreateRecord(
        data,
        url,
        method,
        'User',
      );
      if (success === 'succes') {
        document.querySelector('.add__content').classList.add('hidden');
        setTimeout(function () {
          window.location.reload();
        }, 1000);
      }
    });
  }
}

// Initialize all user functionality
function setupUser() {
  setupUserDataForm();
  setupPasswordForm();
  setupUserInviteForm();
}

export { setupUser };
